import React from 'react';
import {Card, Descriptions} from 'antd';
import {useUser} from '../UserContext';

const Profile: React.FC = () => {
  const {user} = useUser();

  if (!user) {
    return null;
  }

  return (
    <div style={{maxWidth: 600, margin: '32px auto', padding: '0 24px'}}>
      <Card title="Profile">
        <Descriptions column={1} colon={false} layout="vertical">
          <Descriptions.Item label="Name">{user.name}</Descriptions.Item>
          <Descriptions.Item label="Surname">{user.surname}</Descriptions.Item>
          <Descriptions.Item label="Email">{user.email}</Descriptions.Item>
          <Descriptions.Item label="Role">{user.primary_role}</Descriptions.Item>
        </Descriptions>
      </Card>
    </div>
  );
};

export default Profile;
